// janetFetch — fetch for Janet's endpoints, carrying the signed-in session.
// The server takes the acting principal from this token, never from the body
// (api/_lib/janet-auth.js), so every Janet call goes through here.

export async function janetAuthHeaders(extra = {}) {
  let token = null
  try {
    // Loaded on use, so importing this module has no side effects (and the
    // hooks that import it stay testable without a Supabase client).
    const { supabase } = await import('./supabase')
    const { data } = await supabase.auth.getSession()
    token = data?.session?.access_token || null
  } catch { /* no session — the server will answer 401 */ }
  return token ? { ...extra, Authorization: `Bearer ${token}` } : { ...extra }
}

export async function janetFetch(url, options = {}) {
  const headers = await janetAuthHeaders(options.headers || {})
  return fetch(url, { ...options, headers })
}
